import React from 'react';
import { Link } from 'react-router-dom';
import * as ROUTES from '../routes/routes';
import cart from '../assets/images/icons/cart-icon.png';



class Test_Detail_Listing extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            qty: 0
        };
    }
    componentDidMount() {
        window.scrollTo(0, 0);
    }
    render() {
        return (
            <>
                <li className="test-detail-listing-col">
                    <div className="test-detail-listing-box">
                        <div className="image-box">
                            <img src={this.props.labImgSrc} alt="Lab Image" />
                        </div>
                        <div className="detail-box">
                            <div className="test-detail-heading-box">
                                <h4>{this.props.testDetailHeading}</h4>
                                <span className="test-price-box">{this.props.price}</span>
                            </div>
                            <div className="test-detail-description-box">
                                <div className="description-inner">
                                    <div className="adderess-box">
                                        <p className="address-text">{this.props.address}</p>
                                    </div>
                                    <Link className="link-box">{this.props.linkText}</Link>
                                </div>
                                <div className="detail-btn-area">
                                    <div className="cart-btn-box">
                                        <button className="cart-btn">
                                            <img src={cart} alt="" />
                                        </button>
                                    </div>
                                    <Link to={ROUTES.CHECKOUT} className="book-now-btn main-btn">{this.props.buttonText}</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
            </>
        );
    }
};

export default Test_Detail_Listing;    